import { ForwardedRef, RefObject, useImperativeHandle, useRef } from 'react';
import type { XmRangeDatePickerRef } from './rangePickerAntd';

/**
 * Re-publishes the antd picker ref so the wrapper can keep using it internally.
 * @param ref ref the consumer passed to the wrapper
 * @returns ref to attach to the rendered antd RangePicker
 */
export function useRangeHandle(ref: ForwardedRef<XmRangeDatePickerRef>): RefObject<XmRangeDatePickerRef | null> {
  const inner = useRef<XmRangeDatePickerRef>(null);
  const mounted = (): XmRangeDatePickerRef => {
    if (!inner.current) throw new Error('XmRangeDatePicker is not mounted');
    return inner.current;
  };
  useImperativeHandle(ref, () => ({
    get nativeElement(): HTMLDivElement { return mounted().nativeElement; },
    focus: options => inner.current?.focus(options),
    blur: () => inner.current?.blur(),
  }), []);
  return inner;
}
